'use strict';
/**
 * Returns a new Uint8Array created by concatenating the passed ArrayLikes
 *
 * @param {Array<ArrayLike<number>>} arrays
 * @param {Number} length
 * @returns {Uint8Array}
 */

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

function concat(arrays, length) {
  if (!length) {
    length = arrays.reduce(function (acc, curr) {
      return acc + curr.length;
    }, 0);
  }

  var output = new Uint8Array(length);
  var offset = 0;

  var _iterator = _createForOfIteratorHelper(arrays),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var arr = _step.value;
      output.set(arr, offset);
      offset += arr.length;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return output;
}

module.exports = concat;